import { actionCreatorFactory } from 'typescript-fsa';
import { IApiErrorParams } from '@cbridge-packages/api';
import { IMarkupProfile } from './markupProfile.interface';

export namespace MarkupProfileAction {
  const actionCreator = actionCreatorFactory('MarkupProfile');

  interface IMarkupProfileUpdateParams {
    payload: Partial<IMarkupProfile>;
    resolve: (markupProfileId?: IMarkupProfile['markupProfileId']) => void;
  }

  interface IMarkupProfileId {
    profileId: IMarkupProfile['markupProfileId'];
  }

  export const create = actionCreator.async<IMarkupProfileUpdateParams, IMarkupProfileId, IApiErrorParams>('CREATE');
  export const update = actionCreator.async<IMarkupProfileUpdateParams, void, IApiErrorParams>('UPDATE');
  export const remove = actionCreator.async<IMarkupProfileId, void, IApiErrorParams>('REMOVE');

  export const load = actionCreator.async<IMarkupProfileId, IMarkupProfile, IApiErrorParams>('LOAD');
  export const loadList = actionCreator.async<void, IMarkupProfile[], IApiErrorParams>('LOAD_LIST');

  export const destroy = actionCreator('DESTROY');
}
